import { AccessLevel } from "@dentally/enums/access-level";
import { T_CommsMethod } from "../../../graph/patient-short-codes/patient-short-code-base";

export namespace LambdaRequest {
  export interface requestContext {
    accountId?: string;
    apiId?: string;
    authorizer?: {
      lambda: authorizer;
    };
    domainName?: string;
    domainPrefix?: string;
    http?: {
      method: string;
      path: string;
      protocol: string;
      sourceIp: string;
      userAgent: string;
    };
    identity?: {
      sourceIp?: string;
    };
    requestId?: string;
    routeKey?: string;
    stage?: string;
    time?: string;
    timeEpoch?: number;
  }
  export interface event {
    path?: string;
    httpMethod?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "HEAD" | "OPTIONS";
    version?: string;
    routeKey?: string;
    rawPath?: string;
    rawQueryString?: string;
    cookies?: string[];
    headers?: { [name: string]: string };
    queryStringParameters?: queryStringParameters;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Records?: any;
    requestContext?: requestContext;
    body?: string;
    pathParameters?: { [name: string]: string };
    isBase64Encoded?: boolean;
    stageVariables?: { [name: string]: string };
  }
  export interface queryStringParameters {
    [name: string]: string;
  }
  export interface authorizer {
    practice_id?: string;
    patient_id?: string | number;
    patient_session_id?: string;
    user_impersonating_patient?: string;
    uid?: string;
    site_id?: string;
    access_level?: AccessLevel;
    scopes?: string[];
    jwt?: string;
    comms_method?: T_CommsMethod;
    is_verified?: boolean | string;
    referrer?: string;
    /**
     * has domain level settings
     * */
    domain_settings?: boolean;
    /* limit to sites */
    limit_sites?: boolean;

    domain?: string;
    practice_name?: string;
    payment_plan_id?: number;
    /**
     * Version of JWT token issued
     */
    version?: string;

    /**
     * sid is a unique id for users session (regardless of login or not it stays with them)
     */
    sid?: string;

    exp?: number;
    claims?: string[];
    iat?: number;
    restricted_mode?: boolean;
  }

  export const publicAccessLevels = [AccessLevel.PUBLIC, AccessLevel.PUBLIC_IN_PRACTICE];
  export const patientUnauthenticatedAccessLevels = [AccessLevel.PATIENT_UNAUTHENTICATED, AccessLevel.PATIENT_IN_PRACTICE];
  export const patientAccessLevels = [AccessLevel.PATIENT, ...patientUnauthenticatedAccessLevels];
  export const conciergeAccessLevels = [AccessLevel.PUBLIC_IN_PRACTICE, AccessLevel.PATIENT_IN_PRACTICE];
  export const manageAppAccessLevels = [AccessLevel.PRACTICE_ADMIN];
  export enum enumJWTVersion {
    CURRENT = "2.2",
  }
}
